module.exports = __webpack_public_path__ + "img/home-13.0bc84a23.webp";